import React from 'react';
import './FeedSkeleton.css';
import { localizedValue } from '../localization/presentationLanguage';

function SkeletonCard() {
  return (
    <div className="feed-skeleton-list__card" aria-hidden="true">
      <div className="feed-skeleton-list__glow" />
      <div className="feed-skeleton-list__top-line" />

      <div className="feed-skeleton-list__header">
        <div className="feed-skeleton-list__avatar-wrap">
          <div className="feed-skeleton-list__avatar" />
        </div>

        <div className="feed-skeleton-list__header-lines">
          <div className="feed-skeleton-list__line feed-skeleton-list__line--name" />
          <div className="feed-skeleton-list__line feed-skeleton-list__line--meta" />
        </div>

        <div className="feed-skeleton-list__date-pill" />
      </div>

      <div className="feed-skeleton-list__content-shell">
        <div className="feed-skeleton-list__body">
          <div className="feed-skeleton-list__line feed-skeleton-list__line--text-lg" />
          <div className="feed-skeleton-list__line feed-skeleton-list__line--text" />
          <div className="feed-skeleton-list__line feed-skeleton-list__line--text" />
          <div className="feed-skeleton-list__line feed-skeleton-list__line--text-sm" />
        </div>
      </div>

      <div className="feed-skeleton-list__footer-shell">
        <div className="feed-skeleton-list__footer">
          <div className="feed-skeleton-list__pill feed-skeleton-list__pill--short" />
          <div className="feed-skeleton-list__pill" />
          <div className="feed-skeleton-list__pill" />
        </div>
      </div>
    </div>
  );
}

export default function FeedSkeletonList({ count = 3 }) {
  return (
    <>
      <div className="feed-skeleton-list" role="status" aria-label={localizedValue({ es: 'Cargando publicaciones', en: 'Loading posts' })}>
        {Array.from({ length: Math.max(1, Number(count) || 1) }).map((_, index) => (
          <SkeletonCard key={`feed-skeleton-${index}`} />
        ))}
      </div>
    </>
  );
}
